import unescape from 'lodash-es/unescape'
import React from 'react'

import type { Product } from '@modules/Dashboard/Products/types'

import * as S from './ProductName.styled'

export type ProductNameProps = {
  product: Pick<Product, 'name' | 'type'>
}

const getSubtitle = (type: Product['type']) => {
  if (type === 'COMBINED') {
    return 'Combined listing'
  }

  if (type === 'BUNDLE') {
    return 'Product bundle'
  }

  if (type === 'GIFT_CARD') {
    return 'Gift card'
  }
}

export const ProductName: React.FC<ProductNameProps> = ({ product }) => {
  const subtitle = getSubtitle(product.type)

  return (
    <S.Wrapper>
      <S.Title>{unescape(product.name)}</S.Title>
      {subtitle ? <S.Subtitle>{subtitle}</S.Subtitle> : null}
    </S.Wrapper>
  )
}
